<template>
  <div class="page">
    <img class="index-icon" :src="bgUrl" />
    <img v-if="isShowQrCode" class="qrcode" :src="hosQrCode" />
    <!-- <router-link :to="'/makeinvoice'"> -->
    <div class="privacyButton">
      <span class="privacyButtonText" @click="privacButtom">隐私政策?</span>
    </div>
      <div class="index-text">
        <div class="index_bgtext">
          <div>您还在为复印病案烦恼吗？</div>
          <div>使用"病案通"不用来回奔波,</div>
          <div>在家轻松搞定</div>
        </div>
      </div>
    <!-- </router-link> -->

    <div class="notes2" v-if="showNote">
      <div class="notes_top notes_top_line topline_mt">
        <!--  <router-link :to= "'/hos-list'"> -->
        <!--  </router-link> -->
        <div class="notes_top__tips notes_top__tips_in-line">最近一次申请</div>
      </div>

      <router-link class="notes2_bg" :to="'/pay/' + requestId + '/0'">
        <div class="notes_img_left">
          <img class="notes_image_status" :src="imageNoteStatus" />
        </div>

        <div class="text_notes_name">{{ patientName }}</div>
        <div class="express_notes" v-if="requestStatus == 7">
          <img class="express_logo" :src="expressLogo" />
          <span class="text_express_tips">{{ logTracksText }}</span>
        </div>
        <div class="notes2_status" v-else>{{ subType3Name }}</div>
        <div class="notes_img_right">
          <div class="notes_text_right">立即查看</div>
        </div>
      </router-link>
    </div>
    <div class="bottom_block">
      <div class="bottom_tab">
        <div class="tab1">
          <router-link to="/apply-list">
            <img class="bottom_tab_img" src="../assets/apply_logo.png" />
            <div class="bottom_tab_text">我的申请</div>
          </router-link>
        </div>
      </div>
      <div class="bottom_tab_m" @click="enterApply">
        <div class="bottom_image_tab"></div>
        <!-- <img class="bottom_image_m" src="../assets/copy_logo.png"> -->
        <img class="bottom_image_m" src="../assets/copy_logo.png" />
        <div class="bottom_image_text">{{ applyName }}</div>
      </div>
      <a class="bottom_tab">
        <div class="tab1">
          <router-link to="/guide">
            <img class="bottom_tab_img" src="../assets/guide_logo.png" />
            <div class="bottom_tab_text">常见问题</div>
          </router-link>
        </div>
      </a>
    </div>
    <div class="overlay" v-if="isShowTipsLayer" @click="closeTipsLayer">
      <img class="qrcode" @click="previewQrCode()" :src="hosQrCode" />
      <img class="tips-arrow" src="../assets/tips_line.svg" />
      <div class="tips-text">长按二维码关注"病案通"公众号</div>
      <div class="tips-bottom">
        <img class="tips-doctor" src="../assets/tips_doctor.png" />
        <img class="tips-dialog" src="../assets/tips_kuang.svg" />
      </div>
    </div>

    <div class="overlay" v-if="modalHidden">
      <div class="floatDivindex">
        <div class="tip-content">
          <!-- <div class="tip-title">用户隐私政策概要</div> -->
          <div v-html="htRulesNoticeml" class="contentview" />
          <div class="tip-cont-info">
            亲，感谢您信任并使用本小程序病案通！我们依据最新的法律法规、监管政策要求及业务实际情况更新了小程序病案通
            <span
              style="display: inline; color: #009e92"
              @click="gotoPrivacyPolicy"
              >《病案通隐私政策》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="gotoChildInfoRules"
              >《儿童个人信息保护规则》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="gotoCommunityRules"
              >《医服通社区自律公约》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="gotouserRegistration"
              >《医服通用户注册协议》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="goSDK"
              >《第三方SDK类服务商目录》</span
            >，特向您推送本提示！
          </div>
          <div class="e-l tip-button">
            <div>
              <button class="button-2 quitButton" type="default" @click="modalCandel">
                退出
              </button>
            </div>
            <div>
              <button
              class="button-2 agreeButton"
                type="primary"
                :disabled="agreeButton"
                @click="modalConfirm"
              >
                {{ agreeTime }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  <div class="overlay" v-if="privacyHidden">
      <div class="floatDivindex">
        <div class="tip-content">
          <!-- <div class="tip-title">用户隐私政策概要</div>
           -->
           <div v-html="htRulesNoticeml" class="contentview" />
          <div class="tip-cont-info">
            亲，感谢您信任并使用本小程序病案通！我们依据最新的法律法规、监管政策要求及业务实际情况更新了小程序病案通
            <span
              style="display: inline; color: #009e92"
              @click="gotoPrivacyPolicy"
              >《病案通隐私政策》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="gotoChildInfoRules"
              >《儿童个人信息保护规则》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="gotoCommunityRules"
              >《医服通社区自律公约》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="gotouserRegistration"
              >《医服通用户注册协议》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="goSDK"
              >《第三方SDK类服务商目录》</span
            >，特向您推送本提示！
          </div>
          <div class="e-l tip-button">
            <div>
              <button
              class="button-2 agreeButton"
                type="primary"
                @click="Understood"
              >
               知道了
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
 // 埋点
//  let mdtitle;
//  let mdurl;
//  let mdurl_path;
//  let mdreferrer;
//  let mdreferrer_title;
import MobileDetect from "../utils/mobile-detect";
import Base64 from "../utils/base64.min";
// let isFirstDay;
export default {
  name: "home",
  inject: ["reload"],
  data() {
    return {
      hosQrCode: "",
      patientName: "",
      showNote: false,
      subType3Name: "",
      requestStatus: -1,
      userGetPrintType: "",
      expressFlag: "",
      imageNoteStatus: "",
      expressLogo: "",
      logTracksText: "",
      hosId: "",
      path: "",
      requestId: "",
      applyName: "申请",
      isShowTipsLayer: false,
      loginFlag: "0",
      subscribePub: "0",
      hasWx: false,
      bgUrl: require("../assets/index_icon.png"),
      isShowQrCode: true,
      agreeButton: true,
      modalHidden: true,
      agreeTime: 5,
      agressProvisions: '',
      privacyHidden:false,
      htRulesNoticeml:'',
      mdreferrer:'',
      mdreferrer_title:'',
      // qrView:''
      isFirstDay:false,
    };
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     console.log(from, 'from')
  //     //  这里的vm指的就是vue实例，可以用来当做this使用
  //     vm.fromPath = from.path  //获取上一级路由的路径
  //     this.mdreferrer = from.path
  //    this.mdreferrer_title = from.name
  //   })
  // },
  // beforeRouteEnter(to, from) {
  //   // let that = this
  //   console.log(this,'这是that')
  //   console.log(to,from)
  //   console.log(to,'这是to'); //当前
  //   console.log(from,'这是from'); 
  //   this.mdreferrer = from.path;
  //   this.mdreferrer_title = from.name
  // },

  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter");
    console.log("thisInBeforeRouteEnter", this);
    next((vm) => {
      console.log("thisInBeforeRouteEnterNext", this);
      console.log("vm", vm);
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
      // console.log(vm.getMsg());
      vm.mdreferrer= from.path;
      if(from.name == '' || from.name == null || from.name ==undefined){
        vm.mdreferrer_title = '无上一页'
      }else{
        vm.mdreferrer_title = from.name
      }
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
    });
  },
//   beforeRouteUpdate (to, from) {
//   // just use `this`
//   this.name = to.params.name
//   console.log(from,to,'这是beforeRouteUpdate钩子函数')
// },

  components: {},
  created() {
 
    let wxId = localStorage.getItem("wxId");
    let agressProvisions = localStorage.getItem('agressProvisions')
    
        if (agressProvisions == null || agressProvisions == '' || agressProvisions == undefined) {
          console.log('tils')
            this.modalHidden = true
            this.agreeButton = true
            console.log(this.agreeTime)
            verifyCodeTime(this, 4);
        }else{
            this.modalHidden = false
        }
    if (wxId == "13") {
      this.applyName = "申请";
      this.bgUrl = require("../assets/index_icon2.png");
      this.isShowQrCode = false;
    } else {
      this.applyName = "申请复印";
    }
    let hosId = localStorage.getItem("hosId");
    // let qrView = localStorage.getItem("qrView")
    const paramsObj = {
      wxId: wxId,
      hosId: hosId,
    };
    if (this.$util.isNullString(hosId) == false) {
      this.hosId = hosId;
      this.path = "/apply";
    }
    if (this.$util.isNullString(paramsObj.hosId)) {
      paramsObj.hosId = 0;
    }
    this.getHosQrcode(paramsObj);
    if (wxId != 13) {
      this.hasOwnWx(paramsObj);
    }
    console.log(this.$route);
    let params4 = {
      wxId: wxId,
      otherHosId: hosId,
    };
    this.getDefaultHosId(params4);
    this.getUsageRules()
  },
  mounted() {

    // 获取手机版本型号
    //判断数组中是否包含某字符串
    // 调用埋点
    var everypage = JSON.parse(localStorage.getItem('everypage'))
    var indexpage = everypage.indexpage + 1
    everypage.indexpage = indexpage;
    if(indexpage == 1){
     this.isFirstDay = true
    }else{
      this.isFirstDay=false
    }
    localStorage.setItem("everypage", JSON.stringify(everypage));
    
    console.log(this,'这是mounted')
    // var mdreferrer =  localStorage.getItem('mdreferrer')
    var mdreferrer_title =  localStorage.getItem('title')
    if(mdreferrer_title == '' ||mdreferrer_title == undefined ||mdreferrer_title ==null){
      // mdreferrer = '没有上一页'
      mdreferrer_title = '没有上一页'
    }
    var title = this.$route.name;
    localStorage.setItem("mdreferrer_title",mdreferrer_title)
    localStorage.setItem("title",title)
    var url = this.$route.path;
    var url_path = this.$route.path;
    var is_first_Day = this.isFirstDay;
    var preview = 'MpLaunch'
    // var mdreferrer = this.mdreferrer;
    // var mdreferrer_title = this.mdreferrer_title;
    this.$util.BuriedPoint(title,url,url_path,is_first_Day,preview,mdreferrer_title)
    Array.prototype.contains = function (needle) {
      for (i in this) {
        if (this[i].indexOf(needle) > 0) return i;
      }
      return -1;
    };

    var device_type = navigator.userAgent; //获取userAgent信息
    console.log(device_type,'device_type')
    // document.write(device_type); //打印到页面
    var md = new MobileDetect(device_type); //初始化mobile-detect
    console.log(md,'md')
    var os = md.os(); //获取系统
    console.log(os,'os');
    if(os == 'AndroidOS'){
      localStorage.setItem("iosAndro", 'android');
    }else{
      localStorage.setItem("iosAndro", 'ios');
    }
    
    var model = "";
    if (os == "iOS") {
      //ios系统的处理
      os = +md.version("iPhone");
      console.log(os);

      model = md.mobile();
   

    } else if (os == "AndroidOS") {
      //Android系统的处理
      os = md.os() + md.version("Android");
      var sss = device_type.split(";");
      var i = sss.contains("Build/");
      if (i > -1) {
        model = sss[i].substring(0, sss[i].indexOf("Build/"));
      }
    }
    localStorage.setItem("model", model);
    localStorage.setItem("os", os);
    // alert(os + "---" + model);//打印系统版本和手机型号
    console.log(model + "||" + os, "打印系统版本和手机型号");
    // 获取手机版本型号

    this.getWechatVertion();
  },
  computed: {},
  methods: {
    privacButtom:function(){
        this.privacyHidden = true
    },
    Understood:function(){
      this.privacyHidden = false
    },
    // 规则条款
    gotoPrivacyPolicy(){
      window.open('https://m.vmeeting.cn/rules/privacy_policy.html');   
    },
    gotoChildInfoRules(){
      window.open('https://m.vmeeting.cn/rules/child_info_rules.html');   
    },
    gotoCommunityRules(){
      window.open('https://m.vmeeting.cn/rules/community_rules.html');   
    },

    gotouserRegistration(){
      window.open('https://m.vmeeting.cn/rules/user_registration.html');   
    },
    goSDK(){
      window.open('https://m.vmeeting.cn/rules/third_part_sdk.html')
    },
        /**
   * 点击取消
//    */
      modalCandel() {
           setTimeout(function() {
        document.addEventListener(
          'WeixinJSBridgeReady',
          function() {
            this.WeixinJSBridge.call('closeWindow') //安卓手机关闭代码
          },
          false
        )
        this.WeixinJSBridge.call('closeWindow') //苹果手机关闭代码
      }, 50)
        // do something
        console.log('dianji1')
       this.modalHidden = true
        console.log('dianji2')
        window.opener = null;
         console.log('dianji3')
        window.open("about:blank", "_top").close()  
         console.log('dianji4')  
      },

    /**
     *  点击确认
     */
      modalConfirm() {
        // do something
        this.modalHidden = false
        localStorage.setItem('agressProvisions', 1);
        // wx.setStorageSync('agressProvisions', '1')
        // this.getUser();
      },
    // ****** 规则条款******
    getWechatVertion() {
      var version = "";
      if (is_weixn()) {
        var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d]+)/i);
        if (wechatInfo && wechatInfo.length > 1) {
          // 获取微信的版本号
          version = wechatInfo[1];
        }
      }
      console.log(version, "微信版本号");
      localStorage.setItem("version", version);
      return version;
    },
    getHosQrcode(paramsObj) {
      this.$server.getHosQrcode(paramsObj).then((data) => {
        if (data.result == 1) {
          this.hosQrCode = data.hosQrCode;
          console.log(this.hosQrCode);
        }
      });
    },
    getDefaultHosId(params) {
      let that = this;
      this.$server.getDefaultHosId(params).then((data) => {
        if (data.result == 1) {
          let hosId = localStorage.getItem("hosId");
          if (this.$util.isNullString(hosId)) {
            that.hosId = data.hosId;
          }
          if (that.$util.isNullString(that.hosId)) {
            that.path = "/hos-list";
          } else {
            that.path = "/apply";
          }
          const params2 = {
            wxId: params.wxId,
            userId: params.userId,
          };
          that.getLastRequest(params2);
        }
      });
    },
    getUsageRules(){
      let that = this;
      this.$server.getUsageRules().then((data) => {
        if (data.result == 1) {
         console.log(that)
         this.htRulesNoticeml = data.notice
        }
      });
    },
    getLastRequest(params) {
      let that = this;
      this.$server.getLastRequest(params).then((data) => {
        if (data.result == 1) {
          let requestList = data.requests;
          console.log(data);
          if (requestList.length > 0) {
            that.patientName = Base64.decode(requestList[0].patientName);
            that.showNote = true;
            let status = requestList[0].subType3Name;
            let expressFlag = null;
            if (requestList[0].expressCompanyEntity != null) {
              expressFlag = requestList[0].expressCompanyEntity.expressFlag;
            }
            this.requestId = requestList[0].requestId;
            that.subType3Name = that.$util.normalString(status);
            that.requestStatus = requestList[0].requestStatus;
            that.userGetPrintType = requestList[0].userGetPrintType;
            that.expressFlag = expressFlag;
            noteDisplay(that, requestList[0]);
          } else {
            that.showNote = false;
          }
        }
      });
    },
    getLogistics(params) {
      //var params = 'expressNo=' + expressNo + "&expressCompany=" + expressCompany + "&expressTime=" + expressTime;
      let that = this;
      this.$server.logQuery(params).then((res) => {
        console.log(res)
        if (res.result == 1) {
          let logTracks = res.logTracks;
          try {
            var length = logTracks.length;
          } catch (err) {
            // logTracks = []
            length = 0;
          }
          if (length == 0) {
            // that.setData({
            // 	logTracksText: expressNo
            // })
            that.logTracksText = params.expressNo;
          }
          if (length > 0) {
            // that.setData({
            // 	logTracksText: logTracks[0].acceptStation
            // })
            that.logTracksText = logTracks[0].acceptStation;
          }
        }
      });
    },
    enterApply() {
      var areaId = localStorage.getItem("areaId");
      if (areaId != null || (areaId != undefined && areaId) || "") {
        this.$router.push("/hos-list");
      } else {

        console.log(this.hosId);
        if (this.subscribePub == "1" && this.hasWx == false) {
          this.isShowTipsLayer = true;
          return;
        }
        // this.$router.push({
        // 	path: this.path,
        // 	query: {
        // 		hosId: this.hosId
        // 	}
        // })
        if (this.path == "/hos-list") {
          this.$router.push(this.path);
        } else {
          console.log(this.path)
          console.log(this.hosId)
          console.log(this.path + "/" + this.hosId + "/" + "-1")
          console.log('看看path是什么')
          this.$router.push(this.path + "/" + this.hosId + "/" + "-1");
        }
      }
    },
    hasOwnWx(params) {
      this.$server.hasOwnWx(params).then((res) => {
        if (res.result == 1) {
          this.hasWx = res.hasOwnWx;
          this.subscribePub = res.subscribePub;
          if (this.hasWx == false) {
            console.log("未关注公众号");
            this.loginFlag = localStorage.getItem("loginFlag");
            // this.qrView = localStorage.getItem("qrView");
            // console.log(this.qrView) && this.qrView !="1"
            if (this.loginFlag == null || this.loginFlag == "0") {
              this.isShowTipsLayer = true;
            } else {
              this.isShowTipsLayer = false;
            }
          }
        }
      });
    },
    closeTipsLayer() {
      localStorage.setItem("loginFlag", "1");
      this.isShowTipsLayer = false;
    },
  },
};


// 验证倒计时
function verifyCodeTime(that, count) {

    let intervalProcess = setInterval(function () {
  
      if (count == 0) {
        console.log('count = ' + count);
        // $('#verifyBtn').text("获取验证码");
        // $("#verifyBtn").attr("disabled", false);
        that.agreeTime = "已了解"
        that.agreeButton = false
        clearInterval(intervalProcess);
      } else {
  
        // $("#verifyBtn").attr("disabled", true);
        // $('#verifyBtn').text("   (" + count + ")   ");
        that.agreeButton = true,
        that.agreeTime = count,
        count--;
      }
    }, 1000);
  }

// 获取微信版本号
// 判断是否在微信浏览器中打开
function is_weixn() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}



/**
 * 最近一条记录显示操作
 */
function noteDisplay(that, params) {
  switch (params.requestStatus) {
    case 1:
    case 2:
    case 3:
      that.imageNoteStatus = require("../assets/accept.png");
      break;
    case 4:
      that.imageNoteStatus = require("../assets/nopaid.png");
      break;
    case 5:
      that.imageNoteStatus = require("../assets/already_paid.png");
      break;
    case 6:
      if (
        params.userGetPrintType == 1 ||
        params.userGetPrintType == 3 ||
        params.userGetPrintType == 5 ||
        params.userGetPrintType == 7 ||
        params.userGetPrintType == 8
      ) {
        that.imageNoteStatus = require("../assets/already_paid.png");
      } else if (
        params.userGetPrintType == 2 ||
        params.userGetPrintType == 4 ||
        params.userGetPrintType == 6
      ) {
        that.imageNoteStatus = require("../assets/can_pickup.png");
      }
      break;
    case 7:
      if (
        params.userGetPrintType == 1 ||
        params.userGetPrintType == 3 ||
        params.userGetPrintType == 5 ||
        params.userGetPrintType == 7 ||
        params.userGetPrintType == 8
      ) {
        that.imageNoteStatus = require("../assets/had_post.png");
      } else if (
        params.userGetPrintType == 2 ||
        params.userGetPrintType == 4 ||
        params.userGetPrintType == 6
      ) {
        that.imageNoteStatus = require("../assets/finish.png");
      }
      break;
    case 101:
      that.imageNoteStatus = require("../assets/apply_notpass.png");
      break;
    case 102:
      that.imageNoteStatus = require("../assets/user_cancel2.png");
      break;
    case 103:
      that.imageNoteStatus = require("../assets/cancel_refund.png");
      break;
    case 104:
      that.imageNoteStatus = require("../assets/apply_err.png");
      break;
    case 105:
      that.imageNoteStatus = require("../assets/e_close.png");
      break;
    case 106:
      that.imageNoteStatus = require("../assets/sys_close.png");
      break;
    case 107:
      that.imageNoteStatus = require("../assets/apply_timeout.png");
      break;
    default:
      break;
  }
  if (params.requestStatus == 7) {
    let expressNo = params.expressNo;
    if (expressNo != null) {
      let arrayStr = params.expressNo.split("|");
      for (let i = 0; i < arrayStr.length; i++) {
        let expressNo = arrayStr[i];
        const params3 = {
          expressNo: expressNo,
          expressCompany: params.expressCompany,
          expressTime: params.expressTime,
        };
        that.getLogistics(params3);
      }
    }
    let expressFlag = "";
    if (params.expressCompanyEntity != null) {
      expressFlag = params.expressCompanyEntity.expressFlag;
    }
    switch (expressFlag) {
      case "EMS":
        that.expressLogo = require("../assets/ems.png");
        break;
      case "SF":
        that.expressLogo = require("../assets/sf.png");
        break;
      case "ANE":
        that.expressLogo = require("../assets/ane.png");
        break;
      case "JD":
        that.expressLogo = require("../assets/jd_logo.png");
        break;
      case "ST":
        that.expressLogo = require("../assets/ST.png");
        break;
      case "YD":
        that.expressLogo = require("../assets/YD.png");
        break;
      case "ZGYZ":
        that.expressLogo = require("../assets/ZGYZ.png");
        break;
      default:
        break;
    }
  }
}
</script>
<style>
.index-icon {
  width: 100%;
}

.index_bgtext {
  color: #007de4;
  text-align: center;
  font-weight: bold;
}

.index-text {
  position: absolute;
  bottom: 20%;
  width: 100%;
  background-color: #f3fcff;
}

.page {
  width: 100%;
  height: 100vh;
  background-color: #f3fcff;
}

.bottom_tab_middle {
  display: flex;
  display: -webkit-flex;
  background-color: #f3781f;
  justify-content: center;
  /*子元素水平居中*/
  -webkit-justify-content: center;
  align-items: center;
  /*子元素垂直居中*/
  -webkit-align-items: center;
  width: 30%;
  height: 50px;
}

.v_line {
  width: 1px;
  border-style: solid;
  border-left: #fff;
}

.index-icon {
  width: 100%;
  /* height: 90%; */
}

.bottom_block {
  position: fixed;
  bottom: 0;
  display: flex;
  display: -webkit-flex;
  width: 100%;
  background-color: #fff;
  height: 11%;
}

.tab1 {
  text-align: center;
}

.bottom_tab {
  display: flex;
  display: -webkit-flex;
  background-color: #fff;
  justify-content: center;
  /*子元素水平居中*/
  -webkit-justify-content: center;
  align-items: center;
  /*子元素垂直居中*/
  -webkit-align-items: center;
  width: 40%;
  height: 100%;
  text-decoration: none;
}

.bottom_tab_m {
  display: flex;
  display: -webkit-flex;
  background-color: #fff;
  justify-content: center;
  /*子元素水平居中*/
  -webkit-justify-content: center;
  align-items: center;
  /*子元素垂直居中*/
  -webkit-align-items: center;
  width: 20%;
  height: 100%;
}

.bottom_image_m {
  position: fixed;
  width: 100px;
  height: 100px;
  padding: 2px;
  left: 0;
  right: 0;
  margin: auto;
  margin-top: -30px;
}

.bottom_image {
  width: 18px;
  height: 18px;
}

.bottom_image_tab {
  width: 83px;
  height: 83px;
  background-color: #fff;
  margin-top: -45px;
  border-radius: 41.5px;
  border: 1px solid #f3fcff;
  z-index: -1;
}

.bottom_tab_text {
  font-size: 13px;
  color: #000;
  font-weight: 500;
}

.bottom_tab_img {
  width: 30px;
  height: 30px;
  margin-top: 10px;
}

.notes {
  border-radius: 5px;
  overflow: hidden;
  background: #fff;
  /* height: 20%; */
  position: absolute;
  width: 90%;
  bottom: 15%;
  text-align: center;
  margin: 10px;
  left: 10px;
  right: 10px;
  /* height: 20% */
  z-index: 2;
}

.text_notes_title {
  font-size: 15px;
}

.notes_line {
  background-color: #eee;
  width: auto;
  height: 1px;
  margin-left: 5px;
  margin-right: 5px;
}

.in_detail {
  color: #000;
  padding-left: 5px;
  padding-right: 5px;
  margin-right: 10px;
  font-size: 15px;
}

.in_detail::after {
  content: " ";
  display: inline-block;
  height: 6px;
  width: 6px;
  border-width: 2px 2px 0 0;
  border-color: #1aac19;
  border-style: solid;
  -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  position: relative;
  /* top: -2px; */
  /* position: absolute;*/
  top: 50%;
  /* right: 5px; */
  margin-top: -4px;
}

.notes_status {
  color: #fff;
  font-size: 12px;
  width: auto;
  height: auto;
  line-height: 1.5;
  text-align: center;
  margin-left: 5px;
  border-radius: 3px;
  padding-left: 3px;
  padding-right: 3px;
  background: #48bdff;
}

.cancle_line {
  background-color: white;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  height: 60px;
}

.background_notes {
  background-color: #f3fcff;
  position: absolute;
  bottom: 15%;
  text-align: center;
  height: 22%;
  width: 100%;
  z-index: 1;
}

.notes2 {
  border-radius: 5px;
  overflow: hidden;
  background: #f3fcff;
  position: absolute;
  width: 100%;
  height: 150px;
  bottom: 18%;
  text-align: center;
  z-index: 2;
}

.notes_top {
  width: 45%;
  margin: 1.5em auto;
  line-height: 1.6em;
  font-size: 14px;
  text-align: center;
  margin-bottom: 2px;
}

.notes_top__tips {
  display: inline-block;
  vertical-align: middle;
}

.notes_top_line {
  border-top: 1px solid #26d4d5;
  margin-top: 2.4em;
}

.notes_top__tips_in-line {
  position: relative;
  top: -0.9em;
  padding: 0 0.55em;
  background-color: #f3fcff;
  color: #26d4d5;
}

.notes2_bg {
  position: relative;
  width: 80%;
  height: 60px;
  border-radius: 30px;
  background-color: #26d4d5;
  text-align: center;
  display: inline-block;
}

.notes_img_left {
  position: absolute;
  left: 0px;
  width: 55px;
  height: 55px;
  margin-left: 2.5px;
  margin-top: 2.5px;
  /* background-color: #fff; */
  border-radius: 27.5px;
}

.text_notes_name {
  color: #fff;
  font-size: 16px;
  margin-top: 5px;
}

.notes_img_right {
  position: absolute;
  right: 0px;
  top: 0px;
  margin-right: 2.5px;
  margin-top: 2.5px;
  width: 55px;
  height: 55px;
  background-color: #15bfc0;
  border-radius: 27.5px;
  color: #fff;
  font-size: 12px;
}

.notes_text_right {
  position: relative;
  padding: 10px;
  line-height: 1.5;
}

.notes2_status {
  color: #fff;
  font-size: 16px;
}

.express_notes {
  width: 60%;
  margin: auto;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
  /* margin-top: 5px; */
}

.express_logo {
  width: 30px;
  display: inline-block;
  vertical-align: middle;
}

.text_express_tips {
  color: #fff;
  font-size: 13px;
  margin-left: 5px;
}

.notes_text_status {
  position: absolute;
  left: 0px;
  width: 50px;
  height: 50px;
  margin-left: 5px;
  margin-top: 5px;
  /* transform: rotate(-32deg); */
}

.text_status_notes2 {
  color: #fff;
  margin-top: 33%;
  transform: rotate(-18deg);
  font-size: 10px;
}

.focus-step {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: center;
  -webkit-text-align: center;
  justify-content: center;
  /*子元素水平居中*/
  -webkit-justify-content: center;
}

.focus-step_float {
  width: 290px;
  height: 400px;
  background-color: white;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  border-radius: 5px;
  overflow: auto;
  margin-top: 60px;
}

.arrow-logo {
  width: 40px;
  height: 40px;
  float: right;
  margin-right: 80px;
  margin-top: 10px;
}

.focus-step_title {
  margin-top: 30px;
  font-weight: 500;
  font-size: 18px;
}

.line-dotted {
  text-decoration: none;
  /*下划线效果：无下划线*/
  border-bottom: 1px #999 dotted;
  /*加一个只有下边的框 边框为虚线*/
  width: 80%;
  margin: auto;
  text-align: center;
  margin-top: 10px;
}

.focus-step_tip {
  text-align: left;
  font-size: 15px;
  margin-top: 10px;
  margin-left: 20px;
}

.image_tip1 {
  width: 60px;
  margin-left: 10px;
  display: inline-block;
  vertical-align: middle;
}

.focus-step_tip1 {
  text-align: left;
  font-size: 15px;
  margin-top: 20px;
  margin-left: 20px;
}

.image_tip2 {
  width: 200px;
  margin-left: 10px;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 10px;
}

.topline_mt {
  margin-top: 15px;
}

.index_bgtext {
  color: #007de4;
  text-align: center;
  font-weight: bold;
}

.index-text {
  position: absolute;
  bottom: 20%;
  width: 100%;
  background-color: #f3fcff;
}

.notes_image_status {
  width: 55px;
  height: 55px;
}

.close-float {
  position: fixed;
  display: block;
  float: right;
  width: 20px;
  height: 20px;
  right: 40px;
  padding: 10px;
}

.btn_operate {
  border-radius: 3px;
}

.qrcode {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50px;
  right: 10px;
}

.bottom-link {
  position: fixed;
  width: 80px;
  height: 80px;
  padding: 2px;
  left: 0;
  right: 0;
  margin: auto;
  margin-top: -30px;
}

.notes_top {
  width: 45%;
  margin: 1.5em auto;
  line-height: 1.6em;
  font-size: 14px;
  text-align: center;
  margin-bottom: 2px;
}

.notes_top__tips {
  display: inline-block;
  vertical-align: middle;
}

.notes_top_line {
  border-top: 1px solid #26d4d5;
  margin-top: 2.4em;
}

.notes_top__tips_in-line {
  position: relative;
  top: -0.9em;
  padding: 0 0.55em;
  background-color: #f3fcff;
  color: #26d4d5;
}

.notes2_bg {
  position: relative;
  width: 80%;
  height: 60px;
  border-radius: 30px;
  background-color: #26d4d5;
  text-align: center;
  display: inline-block;
}

.notes_img_left {
  position: absolute;
  left: 0px;
  width: 55px;
  height: 55px;
  margin-left: 2.5px;
  margin-top: 2.5px;
  /* background-color: #fff; */
  border-radius: 27.5px;
}

.text_notes_name {
  color: #fff;
  font-size: 16px;
  margin-top: 5px;
}

.notes_img_right {
  position: absolute;
  right: 0px;
  top: 0px;
  margin-right: 2.5px;
  margin-top: 2.5px;
  width: 55px;
  height: 55px;
  background-color: #15bfc0;
  border-radius: 27.5px;
  color: #fff;
  font-size: 12px;
}

.notes_text_right {
  position: relative;
  padding: 10px;
  line-height: 1.5;
}

.notes2_status {
  color: #fff;
  font-size: 16px;
}

.express_notes {
  width: 60%;
  margin: auto;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
  /* margin-top: 5px; */
}

.express_logo {
  width: 30px;
  display: inline-block;
  vertical-align: middle;
}

.text_express_tips {
  color: #fff;
  font-size: 13px;
  margin-left: 5px;
}

.notes_text_status {
  position: absolute;
  left: 0px;
  width: 50px;
  height: 50px;
  margin-left: 5px;
  margin-top: 5px;
  /* transform: rotate(-32deg); */
}

.text_status_notes2 {
  color: #fff;
  margin-top: 33%;
  transform: rotate(-18deg);
  font-size: 10px;
}

.bottom_image_text {
  position: fixed;
  padding: 2px;
  bottom: 0;
  margin: auto;
  font-size: 15px;
  font-weight: 500;
}

.tips-arrow {
  width: 50px;
  position: absolute;
  top: 150px;
  right: 60px;
}

.tips-text {
  border: 1px solid #fff;
  background: #fff;
  border-radius: 6px;
  color: red;
  position: absolute;
  top: 200px;
  right: 20px;
  padding: 10px;
  font-weight: bold;
}

.tips-bottom {
  position: absolute;
  bottom: 80px;
}

.tips-dialog {
  width: 65%;
  margin-bottom: 20px;
}

.tips-doctor {
  width: 30%;
  margin-left: 10px;
}
.floatDivindex {
  width: calc(100% - 15px * 2);
   height: calc(100% - 120px * 2);
  background-color: white;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  /*margin-top: 80px;*/
  border-radius: 5px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.e-l {
  display: flex;
  justify-content: space-around;
}

.tip-title {
  font-size: 20px;
  margin: 20px;
  text-align: center;
  font-weight: bold;
}
.tip-content {
  /* position: relative; */
  font-size: 15px;
  padding: 0 0rpx;
  text-align: left;
}
.tip-info {
  padding: 0 30px;
  border: none;
   height: 40px;
  line-height: 40px;
  margin: 20px auto;
  border-radius: 6px;
  position: relative;
}
.tip-button {
  width: 100%;
  text-align: center;
  /* position: absolute; */
  /* bottom: 0; */
  margin-bottom: 30px;
  margin-top: 30px;
}

.button-2{
  width: 100px;
    /* padding: 0rpx 100rpx; */
  
 
  padding: 1px 3px;
  border-radius: 3px;
  font-size: 14px;
  margin: 5px 0;
}
.quitButton{
 border: 1px solid #666666;
 color: #666;
}
.agreeButton{
 border: 1px solid #15bfc0;
 color: white;
 background: #15bfc0;
}
.privacyButton{
   text-align: right;
  /*margin-bottom: 20px; */
  position: absolute;
  bottom: 43%;
  width: 100%;
  right: 0;
  /* background-color: #f3fcff; */
}
.privacyButtonText{
  /* width: 120px; */
  padding: 5px 10px 5px 20px;
  background-color: #f3fcff;
  margin-top: 20px;
  box-shadow: 0 2px 0px rgba(239,239,244,100);
  border: 1px solid #5ab15a;
  color: #1aad19;
  border-radius: 20px 0px 0px 20px;
}
.tip-cont-info {
  width: 300px;
  /* height: 40px;
  border: 1px solid #dddddd; */
  line-height: 40px;
  margin: 20px auto;
  border-radius: 6px;
  position: relative;
}
</style>
